import { connect } from 'react-redux';
import withPGTranslation from '../../../config/withPGTranslation';
import Footer from './footer';

const mapStateToProps = ({ application: { dynamicConfig } }) => ({
  appStoreUrl: dynamicConfig?.appStoreUrl,
  playStoreUrl: dynamicConfig?.playStoreUrl,
  satisfactionGuarantee: dynamicConfig?.uiSettings?.satisfactionGuarantee
});

export default connect(mapStateToProps)(withPGTranslation(Footer));
